interface EmptySearchProps {
  width?: number
  height?: number
  className?: string
}

/**
 * 시설 검색 결과 없음 SVG 일러스트.
 *
 * 돋보기 + 물음표 + 건물 실루엣
 * 인디고 블루 + 그레이 톤, 심플한 라인 스타일.
 */
export default function EmptySearch({
  width = 200,
  height = 160,
  className,
}: EmptySearchProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="검색 결과 없음"
    >
      {/* 배경 원 */}
      <circle cx="100" cy="80" r="60" fill="#EEF2FF" />

      {/* 건물 실루엣 (뒤쪽) */}
      <rect x="60" y="70" width="28" height="40" rx="3" fill="#DBE4FF" />
      <rect x="65" y="76" width="6" height="6" rx="1" fill="#EEF2FF" />
      <rect x="77" y="76" width="6" height="6" rx="1" fill="#EEF2FF" />
      <rect x="65" y="86" width="6" height="6" rx="1" fill="#EEF2FF" />
      <rect x="77" y="86" width="6" height="6" rx="1" fill="#EEF2FF" />
      <rect x="70" y="98" width="8" height="12" rx="1" fill="#EEF2FF" />

      <rect x="95" y="60" width="32" height="50" rx="3" fill="#D5D3CD" />
      <rect x="100" y="66" width="7" height="6" rx="1" fill="#E8E6E1" />
      <rect x="113" y="66" width="7" height="6" rx="1" fill="#E8E6E1" />
      <rect x="100" y="76" width="7" height="6" rx="1" fill="#E8E6E1" />
      <rect x="113" y="76" width="7" height="6" rx="1" fill="#E8E6E1" />
      <rect x="100" y="86" width="7" height="6" rx="1" fill="#E8E6E1" />
      <rect x="113" y="86" width="7" height="6" rx="1" fill="#E8E6E1" />
      <rect x="106" y="98" width="10" height="12" rx="1" fill="#E8E6E1" />

      {/* 바닥 라인 */}
      <line x1="45" y1="110" x2="155" y2="110" stroke="#D5D3CD" strokeWidth="2" strokeLinecap="round" />

      {/* 돋보기 */}
      <circle cx="90" cy="50" r="18" stroke="#4C6EF5" strokeWidth="3" fill="white" fillOpacity="0.9" />
      <line x1="103" y1="63" x2="114" y2="74" stroke="#4C6EF5" strokeWidth="3" strokeLinecap="round" />

      {/* 물음표 */}
      <path
        d="M87 42C87 39 89 37 92 37C95 37 97 39 97 41.5C97 44 95 45 93 46L92 47"
        stroke="#4C6EF5"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="92" cy="52" r="1.5" fill="#4C6EF5" />

      {/* 장식 점 */}
      <circle cx="140" cy="40" r="3" fill="#DBE4FF" />
      <circle cx="55" cy="45" r="2" fill="#DBE4FF" />
      <circle cx="150" cy="70" r="2.5" fill="#E8E6E1" />
    </svg>
  )
}
